<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col sm="4">
        <div class="form-group">
          <label
                  for="exsbwarehouse_type"
                  class="form-control-label">{{$t('views.exsbwarehouses.form.type')}}:</label>
          <fg-input :error="violations.type">
            <el-select
                    id="exsbitem_type"
                    :class="['select-default', isInvalid('type') ? 'select-danger' : '']"
                    :placeholder="$t('views.exsbwarehouses.form.type')"
                    filterable
                    v-model="item.type">
              <el-option v-for="option in warehouseTypes"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('type')"
                  class="invalid-feedback">{{ violations.type }}</div>
        </div>
      </b-col>
      <b-col sm="4">
        <div class="form-group">
          <label
                  for="exsbwarehouse_name"
                  class="form-control-label">{{$t('views.exsbwarehouses.form.name')}}:</label>
          <input
                  id="exsbwarehouse_name"
                  v-model="item.name"
                  :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('name', $event.target.value)">
          <div
                  v-if="isInvalid('name')"
                  class="invalid-feedback">{{ violations.name }}</div>
        </div>
      </b-col>
      <b-col sm="4">
        <div class="form-group">
          <label
                  for="exsbwarehouse_idCustom"
                  class="form-control-label">{{$t('views.exsbwarehouses.form.idCustom')}}:</label>
          <input
                  id="exsbwarehouse_idCustom"
                  v-model="item.idCustom"
                  :class="['form-control', isInvalid('idCustom') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('idCustom', $event.target.value)">
          <div
                  v-if="isInvalid('idCustom')"
                  class="invalid-feedback">{{ violations.idCustom }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      warehouseTypes: []
    }
  },

  watch: {
    item: function (itemUpdate) {
      // change data to form if needed
      itemUpdate.type = itemUpdate.type['@id']
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.getWarehouseTypes()
  },

  methods: {
    getWarehouseTypes () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_s_b_warehouse_types', {
          params
        })
        .then(response => {
          this.warehouseTypes = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
